import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 6,
    maxLength: 20,
  },
  skuCode: {
    name: "skuCode",
    label: "SKU Code",
    type: "text",
    errorMsg: "SKU Code is required",
    required: true,
    editable:false,
    //disabled: true,
    maxLength: 50,
  },
  sellerSKU: {
    name: "sellerSKU",
    label: "Seller SKU",
    type: "text",
    maxLength: 50,
  },
  category: {
    name: "category",
    label: "Category",
    type: "text",
    errorMsg: "Category is required",
    required: true,
    maxLength: 30,
  },
  size: {
    name: "size",
    label: "Product Size",
    type: "text",
    maxLength: 30,
  },
  skuGroup: {
    name: "skuGroup",
    label: "SKU Group",
    type: "text",
    errorMsg: "SKU Group is required",
    required: true,
    maxLength: 30,
  },
  color: {
    name: "color",
    label: "Product Colour",
    type: "text",
    xs: 6,
    maxLength: 30,
  },
  skuSubGroup: {
    name: "skuSubGroup",
    label: "SKU Sub Group",
    type: "text",
    errorMsg: "SKU Sub Group is required",
    required: true,
    maxLength: 30,
  },
  style: {
    name: "style",
    label: "Product Style",
    type: "text",
    maxLength: 30,
  },
  descriptions1: {
    name: "descriptions1",
    label: "Descriptions 1",
    type: "text",
    maxLength: 100,
    errorMsg: "Descriptions 1 is required",
    required:true
  },
  movementType: {
    name: "movementType",
    label: "Movement Type",
    type: "select",
    errorMsg: "Movement Type is required",
    required: true,
  },
  descriptions2: {
    name: "descriptions2",
    label: "Descriptions 2",
    type: "text",
    maxLength: 100,
  },
  pickingRules: {
    name: "pickingRules",
    label: "Picking Rules",
    type: "select",
    errorMsg: "Picking Rules is required",
    required: true,
  },
  currencyCode: { name: "currencyCode", label: "Currency Code", type: "select", maxLength: 10,errorMsg:"Currency Code is required",required:true },
  shelfLife: { name: "shelfLife", label: "Shelf Life (Days)", type: "number" },
  costPrice: { name: "costPrice", label: "Cost Price", type: "number" },
  expiryDateCtrl: { name: "expiryDateCtrl", label: "Expiry Date Control", type: "switch",readOnly:true },
  sellingPrice: { name: "sellingPrice", label: "Selling Price", type: "number", xs: 6 },
  manDateCtrl: { name: "manDateCtrl", label: "Manufacturing Date Control", type: "switch" },
  manualLotCtrl: { name: "manualLotCtrl", label: "Manual Lot No Control", type: "switch" },
  mlnCtrl: { name: "mlnCtrl", label: "Manufacturing Lot No Control", type: "switch",readOnly:true },
  serialNbrCtrl: { name: "serialNbrCtrl", label: "Serial Number Control", type: "switch" },
  inbSerialNbrCtrl: { name: "inbSerialNbrCtrl", label: "Inbound Serial Number Control", type: "switch" },
  spclHandlingInst: {
    name: "spclHandlingInst",
    label: "Special Handling Instruction",
    type: "text",
    xs: 6,
    maxLength: 250,
  },
  //productImage: { name: "productImage", label: "Product Image", type: "file" },
};

const{
  customerCode,skuCode,sellerSKU,category,size,skuGroup,color,skuSubGroup,style,
  descriptions1,movementType,descriptions2,pickingRules,currencyCode,shelfLife,
  costPrice,expiryDateCtrl,sellingPrice,manDateCtrl,manualLotCtrl,mlnCtrl,serialNbrCtrl,inbSerialNbrCtrl,spclHandlingInst
}=formField

export const form = {
  formId: "new-sku-form",
  formRender: [[customerCode], 
  [skuCode,sellerSKU], 
  [category,size], 
  [skuGroup,color], 
  [skuSubGroup,style], 
  [descriptions1,movementType], 
  [descriptions2,pickingRules], 
  [{type:"title",label:"SKU Costing"},{type:"title",label:"Date Control"}], 
  [currencyCode,shelfLife],
  [costPrice,expiryDateCtrl], 
  [sellingPrice], 
  [{type:"title",label:"Warehouse Control Setting"}],
  [manDateCtrl,manualLotCtrl], 
  [mlnCtrl,serialNbrCtrl], 
  [spclHandlingInst,inbSerialNbrCtrl], 
  //[productImage]
],
};

export const formRender=[
  [customerCode], 
  [skuCode,category,skuGroup,skuSubGroup], 
  [sellerSKU,size,color,style], 
  [descriptions1,descriptions2,movementType,pickingRules],
  [{type:"title",label:"SKU Costing"},"",{type:"title",label:"Date Control"},""], 
  [currencyCode,costPrice,shelfLife,expiryDateCtrl],
  [sellingPrice], 
  [{type:"title",label:"Warehouse Control Setting"}],
  [manDateCtrl,mlnCtrl,manualLotCtrl,serialNbrCtrl], 
  [spclHandlingInst,inbSerialNbrCtrl], 
  //[productImage]
]

// function getInitialValues(formField) {
//   let initialValues = {};
//   formField.forEach((field) => {
//     field.forEach((x) => {
//       if (x.type === "text" || x.type === "select") {
//         initialValues[x.name] = "";
//       } else if (x.type === "number") {
//         initialValues[x.name] = 0;
//       } else if (x.type === "switch") {
//         initialValues[x.name] = x.default ?? false;
//       } else if (x.type === "file") {
//         initialValues[x.name] = [];
//       }
//     });
//   });
//   return initialValues;
// }

// function getFormField(formField) {
//   let initialFormField = {};
//   formField.forEach((field) => {
//     field.forEach((x) => {
//       initialFormField[x.name] = x;
//     });
//   });
//   return initialFormField;
// }

export const initialValues=getInitialValues(formField)

//const { customerCode, skuCode, category, skuGroup, skuSubGroup } = getFormField(form.formRender);

export const skuValidations = Yup.object().shape({
  [customerCode.name]: Yup.string().nullable().max(customerCode.maxLength).required(customerCode.errorMsg),
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
  [category.name]: Yup.string().nullable().max(category.maxLength).required(category.errorMsg),
  [skuGroup.name]: Yup.string().nullable().max(skuGroup.maxLength).required(skuGroup.errorMsg),
  [skuSubGroup.name]: Yup.string().nullable().max(skuSubGroup.maxLength).required(skuSubGroup.errorMsg),
  [descriptions1.name]: Yup.string().nullable().max(descriptions1.maxLength).required(descriptions1.errorMsg),
  [movementType.name]: Yup.string().nullable().required(movementType.errorMsg),
  [pickingRules.name]: Yup.string().nullable().required(pickingRules.errorMsg),
  [currencyCode.name]: Yup.string().nullable().required(currencyCode.errorMsg),
});

/**
 * Customer Code
 * SKU Code, Seller SKU
 * Category, Product Size
 * SKU Group, Product Style
 * Descriptions 1, Movement Type
 * Descriptions 2, Picking Rules
 */
